<template>
  <div class="UpdateCase">
    <div class="titlePage">Actualizar Caso - {{this.CaseRef.CaseDetail}} </div>
    <va-notification color="danger" v-if="refNoReport" class="refNoData">El servicio no se encuentra activo.</va-notification>
    <va-notification color="info" v-if="addRExito" class="refNoData">Se actualizo correctamente el caso solicitado.</va-notification>
    <div class="flex xs12" v-if="totaldata">
        <va-card>
            <table class="table">
                <tbody>
                <tr>
                    <th class="titleData" scope="row">Limite de casos por Persona</th>
                    <td>{{this.CaseRef.CaseNumLimit}}</td>
                    <td class="titleData" >Detalle</td>
                    <td>{{this.CaseRef.CaseDetail}}</td>
                </tr>
                <tr>
                    <th class="titleData" scope="row">Fecha Inicial</th>
                    <td>{{this.convertDateTime(this.CaseRef.DateStartCase)}}</td>
                    <td class="titleData">Fecha Final</td>
                    <td>{{this.convertDateTime(this.CaseRef.DateEndCase)}}</td>
                </tr>
                <tr>
                    <th class="titleData" scope="row">Tipo de Caso</th>
                    <td>{{this.CaseRef.CaseTypeName}}</td>
                    <td class="titleData">Estado del Caso</td>
                    <td>
                    <div v-if="this.CaseRef.CaseStatus" >
                        Activo
                    </div>
                    <div class="valDetail" v-else>
                        Inactivo
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
        </va-card>
    </div>
      <div class="Separador" v-if="this.CaseRef.CaseReason !== 'FORM'">
        <div class="titlePage" v-if="totaldata">Facultades / Programas / Cursos</div>
      </div>
      <div class="flex xs12" v-if="this.CaseRef.CaseReason !== 'FORM'">
        <va-card>
          <va-accordion>
            <template v-for="item of this.CaseRef.CaseFaculty">
                <va-collapse :key="item.FacultyID" v-if="item.FacultyPrograms">
                <span slot="header"> {{item.FacultyName}} </span>
                <div slot="body">
                    <template v-for="itemProList of item.FacultyPrograms">
                        <div :key="itemProList.ProgramId">
                          <va-notification color="warning">{{itemProList.ProgramName}}</va-notification>
                          <div class="row margenref" v-if="itemProList.ProgramCourse">
                            <template v-for="itemCourList of itemProList.ProgramCourse">
                              <div :key="itemCourList.CourseId" class="custom-control custom-checkbox col-md-6">
                                <template v-if="itemCourList.CourseStatus">
                                  <input v-model="modelArray[item.FacultyID + '_' + itemProList.ProgramId + '_' + itemCourList.CourseId + '_' + itemCourList.CourseStatus[0].CaseStatusId]" type="checkbox" class="custom-control-input" :id="item.FacultyID + '_' + itemProList.ProgramId + '_' + itemCourList.CourseId + '_' + itemCourList.CourseStatus[0].CaseStatusId" />
                                  <label class="custom-control-label" :for="item.FacultyID + '_' + itemProList.ProgramId + '_' + itemCourList.CourseId + '_' + itemCourList.CourseStatus[0].CaseStatusId">{{itemCourList.CourseName}}</label>
                                </template>
                                <template v-else>
                                  <input v-model="modelArray[item.FacultyID + '_' + itemProList.ProgramId + '_' + itemCourList.CourseId + '_0']" type="checkbox" class="custom-control-input" :id="item.FacultyID + '_' + itemProList.ProgramId + '_' + itemCourList.CourseId + '_0'" />
                                  <label class="custom-control-label" :for="item.FacultyID + '_' + itemProList.ProgramId + '_' + itemCourList.CourseId + '_0'">{{itemCourList.CourseName}}</label>
                                </template>
                              </div>
                            </template>
                          </div>
                          <div v-else class="margenref"><strong>No se encuentran cursos activos para este programa.</strong></div>
                        </div>
                    </template>
                </div>
                </va-collapse>
            </template>
          </va-accordion>
          <div class="text-right">
            <button class="loginbtn primaryBtn primaryBtn" type="submit" v-on:click="this.UpdateCase">
                <va-icon name="fa fa-database" size="60" /> Actualizar Caso
            </button>
          </div>
        </va-card>
      </div>
  </div>
</template>

<script>
import ListHistory from '@/components/data-tables/DataHistory.vue'
import IberoHelpers from '@/store/helpers.js'

export default {
  name: 'UpdateCase',
  data () {
    return {
      totaldata: false,
      CaseRef: [],
      ModeldataAdd: [],
      ModeldataUpt: [],
      modelArray: {},
      refNoReport: false,
      addRExito: false,
    }
  },
  components: {
    ListHistory,
  },
  methods: {
    convertDateTime (valDataTime) {
      return IberoHelpers.dataTimeObjDate(valDataTime)
    },
    UpdateCase () {
      this.addRExito = false
      let loader = this.$loading.show()
      this.ModeldataAdd.length = 0
      this.ModeldataUpt.length = 0
      for (const items in this.modelArray) {
        var listDataMR = items.split('_')
        if (listDataMR[3] === '0') {
          this.ModeldataAdd.push({ Id_Case: this.CaseRef.CaseId, Id_Faculty: listDataMR[0], Id_Program: listDataMR[1], Id_Course: listDataMR[2], Sta_Status: this.modelArray[items] })
        } else {
          this.ModeldataUpt.push({ Id_Case_Faculty_Program_Course: listDataMR[3], Id_Case: this.CaseRef.CaseId, Id_Faculty: listDataMR[0], Id_Program: listDataMR[1], Id_Course: listDataMR[2], Sta_Status: this.modelArray[items] })
        }
      }
      var ProcessData = IberoHelpers.processCase(this.$store, this.ModeldataAdd, this.ModeldataUpt)
      ProcessData.then(Response => {
        if (Response.data) {
          this.totaldata = false
          this.addRExito = true
          this.loadFacultyCase()
          loader.hide()
        } else {
          loader.hide()
        }
      })
    },
    loadFacultyCase () {
      let loader = this.$loading.show()
      var ListCase = IberoHelpers.getCasedata(this.$store, 2, this.$route.params.id)
      ListCase.then(Response => {
        this.modelArray = {}
        this.CaseRef = Response.data.Case[0]
        for (var i = 0; i < this.CaseRef.CaseFaculty.length; i++) {
          if (this.CaseRef.CaseFaculty[i].FacultyPrograms) {
            for (var j = 0; j < this.CaseRef.CaseFaculty[i].FacultyPrograms.length; j++) {
              if (this.CaseRef.CaseFaculty[i].FacultyPrograms[j].ProgramCourse) {
                for (var m = 0; m < this.CaseRef.CaseFaculty[i].FacultyPrograms[j].ProgramCourse.length; m++) {
                  var refen = this.CaseRef.CaseFaculty[i].FacultyID + '_' + this.CaseRef.CaseFaculty[i].FacultyPrograms[j].ProgramId + '_' + this.CaseRef.CaseFaculty[i].FacultyPrograms[j].ProgramCourse[m].CourseId
                  if (this.CaseRef.CaseFaculty[i].FacultyPrograms[j].ProgramCourse[m].CourseStatus) {
                    this.modelArray[refen + '_' + this.CaseRef.CaseFaculty[i].FacultyPrograms[j].ProgramCourse[m].CourseStatus[0].CaseStatusId] = this.CaseRef.CaseFaculty[i].FacultyPrograms[j].ProgramCourse[m].CourseStatus[0].CaseStatusCourse
                  } else {
                    this.modelArray[refen + '_0'] = false
                  }
                }
              }
            }
          }
        }
        loader.hide()
        this.totaldata = true
      })
    },
  },
  created: function () {
    this.loadFacultyCase()
  },
}
</script>